const enUSSiteWidgetLang = {
  consentBanner: {
    title: "We Respect Your Privacy",
    text: 'By clicking "Accept All", you consent to our use of technologies like cookies to enable essential site functionality, to serve personalized marketing or content, and to analyze traffic to improve your browsing experience. You can also choose to customize your settings or you can click "Deny All" to decline anything that is not considered strictly necessary. Your settings can be adjusted at any time.',
    link: "View Policy",
    gcmLink: "Google Privacy Policy",
    acceptButton: "Accept All",
    denyButton: "Deny All",
    customizeButton: "Customize",
    gpcText: "Your Opt-Out Preference Signal Was Honored",
    doNotSellText: "Do Not Sell or Share My Personal Information"
  },
  floatingButton: {
    tab: "Privacy"
  },
  placeholders: {
    acceptButton: "Accept",
    acceptText: "Content blocked by privacy settings. To view it, accept this consent category:"
  },
  privacyCenter: {
    error: {
      title: "Error",
      text: "An unexpected problem has occurred. Please try again."
    },
    noItems: "No Items",
    required: "Required",
    tabTitle: "Privacy Center",
    consentHistory: {
      title: "Consent History",
      noHistory: "There are no history items to display.",
      consentEvents: {
        title: "Consent Event Details",
        name: "Name",
        description: "Description",
        date: "Date",
        disclosure: "Read Full Disclosure",
        link: "Link"
      },
      states: {
        accepted: "Accepted",
        declined: "Declined",
        implied: "Implied"
      }
    },
    consentCategory: {
      strictlyNecessary: {
        title: "Strictly Necessary",
        text: "These items are required to ensure core functionality. As the website will not function properly without them, they are enabled by default and this setting cannot be changed."
      },
      analytics: {
        title: "Analytics",
        text: "This enables us to improve our website by collecting and reporting information on its usage. It helps us better understand how people interact with the website and if there are any technical issues that could impact your experience."
      },
      functional: {
        title: "Functional",
        text: "This allows us to provide you with a more personalized experience on our website and to remember choices you make when you use our website. For example, we may remember your preferred language, your region or timezone, or other personal settings like login information."
      },
      marketing: {
        title: "Marketing",
        text: "This helps us deliver personalized marketing content to you, including advertisements, that is more relevant to your interests. This may also be used to limit the number of times you see certain marketing content and to measure the effectiveness of different marketing campaigns."
      },
      unclassified: {
        title: "Unclassified",
        text: "These are items that have not been classified yet. We are in the process of classifying them with the help of their providers."
      },
      limitPiiUse: {
        title: "Limit the Use of My Sensitive Personal Information",
        text: "When you enable this option, you are indicating that you want us to limit the use and disclosure of sensitive personal information to certain business purposes, such as helping to ensure data security and integrity, non-personalized marketing, performing services on behalf of the business, or doing things to verify, maintain, or improve the quality and safety of our products and services."
      },
      doNotSell: {
        title: "Do Not Sell or Share My Personal Information",
        text: "When you enable this option, you are indicating that you do not want us to sell or share/disclose your personal information for online marketing activities. When you enable this option, it will also disable Marketing consent at that time."
      },
      gpc: {
        title: "Global Privacy Control",
        text: "Browsers provide a mechanism to capture users privacy settings, if we detect this signal we record that it was present when consent was captured."
      },
      privacyPolicy: {
        title: "Privacy Policy"
      },
      termsOfService: {
        title: "Terms of Service"
      },
      agreement: {
        title: "Agreement"
      },
      details: {
        name: "Name",
        domain: "Domain",
        pattern: "Pattern"
      }
    },
    consentSettings: {
      additionalDetailsButton: "Additional Details",
      alwaysActive: "Always Active",
      tabTitle: "Consent Settings",
      title: "My Settings",
      text: "When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience.",
      confirmButton: "Confirm Choices",
      unidentifiedCompany: "Unidentified Company",
      cancelButton: "Cancel",
      submitButton: "Submit"
    },
    disclosures: {
      title: "Our Privacy Disclosures",
      text: "Details around our policies related to data privacy can be found here. You may have additional rights regarding your data, depending on where you live."
    },
    privacyRequests: {
      title: "Privacy Requests",
      text: "In select geographic areas, you may request a copy of your data or request to have your data changed or removed once per calendar year.",
      optionsTitle: "Privacy Options",
      optionsButton: "See My Options",
      getDetailsButton: "Get Details",
      requestDetails: {
        title: "Request Details",
        text: "To protect your privacy, request details will be sent to the email address on file.",
        required: "Request details are required."
      },
      requests: {
        text: "Please provide details about your request here.",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        emailRequired: "A valid email address is required.",
        phone: "Phone",
        phoneRequired: "A valid phone number is required.",
        error: "An unexpected problem has occurred while submitting your request. Please try again.",
        warning: "Warning"
      },
      verificationCodes: {
        title: "Enter Verification Code",
        text: "A verification code has been sent to your email address. Please enter it below.",
        placeholder: "Enter verification code.",
        requirements: "Code does not meet requirements.",
        required: "A verification code is required.",
        invalid: "An error occurred verifying your request. Please check your verification code and try again."
      },
      statuses: {
        acknowledged: "Acknowledged",
        submitted: "Submitted",
        pendingVerification: "Pending Verification",
        resolved: "Resolved"
      },
      changeRequest: {
        title: "Change Data",
        text: "This will submit a request to us to modify one or more pieces of your data in our systems. Submissions require email confirmation, specifics about the change(s) requested, and can usually only be made once per year."
      },
      deleteRequest: {
        title: "Delete Data",
        text: "This will submit a request to us to remove all of your data from our systems as required by law. Once processed, your account will be closed and all data and preferences will no longer be recoverable. Please confirm that you want to proceed."
      },
      doNotSellRequest: {
        title: "Don't Sell or Share",
        text: "This will submit a do not sell or share my data request to us that will be processed as required by law. Submissions require email confirmation."
      },
      viewRequest: {
        title: "Get a Copy",
        text: "This will submit a request to us to send you a copy of your data that we have within our systems. Submissions require email confirmation and can usually only be made once per year."
      }
    }
  }
};
export {
  enUSSiteWidgetLang
};
//# sourceMappingURL=en_US.js.map
